module.exports = __webpack_public_path__ + "static/media/nano-dark-blue.5bb273e6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/arts/nano-dark-blue.jpg
// module id = 428
// module chunks = 0